<div
  class="fixed inset-0  z-50  flex items-center justify-center bg-black/50 pt-8 px-4 pb-8 overflow-y-auto transition-opacity duration-300"
  [class.opacity-0]="!isVisible" [class.opacity-100]="isVisible" (click)="closeModal()">

  <div
    class="bg-white dark:bg-slate-900 w-full max-w-5xl rounded-[2rem] shadow-2xl overflow-hidden transition-all duration-300 relative text-slate-800 dark:text-slate-200"
    [class.translate-y-4]="!isVisible" [class.translate-y-0]="isVisible" (click)="$event.stopPropagation()">

    <!-- Decorative Backdrop Blobs for Glassmorphism highlights -->
    <!-- <div
      class="absolute top-10 left-1/4 w-80 h-80 bg-amber-400/10 dark:bg-amber-400/5 rounded-full blur-3xl -z-10 animate-pulse pointer-events-none"
      style="animation-duration: 8s;"></div> -->
    <div
      class="absolute bottom-20 right-1/4 w-96 h-96 bg-blue-400/10 dark:bg-blue-400/5 rounded-full blur-3xl -z-10 animate-pulse pointer-events-none"
      style="animation-duration: 12s;"></div>

    <!-- Modal Header -->
    <div class="flex items-center justify-between px-6 py-4 border-b border-slate-100 dark:border-slate-800/80">
      <div class="flex items-center gap-3">
        <div
          class="w-9 h-9 rounded-2xl bg-amber-400/10 dark:bg-amber-400/20 flex items-center justify-center text-amber-500">
          <span class="material-icons text-xl">account_balance_wallet</span>
        </div>
        <div>
          <h2 class="text-lg font-extrabold text-slate-900 dark:text-white">รายละเอียดบัญชีเติมเงิน</h2>
          <p class="text-[10px] text-slate-500 dark:text-slate-400 font-medium">จัดการข้อมูล ปรับปรุงยอด
            และตรวจสอบประวัติธุรกรรมรายบัญชี</p>
        </div>
      </div>
      <button (click)="closeModal()"
        class="w-8 h-8 flex items-center justify-center rounded-xl bg-slate-50 hover:bg-slate-100 dark:bg-slate-800 dark:hover:bg-slate-700 text-slate-400 hover:text-slate-650 dark:hover:text-slate-250 transition-colors cursor-pointer">
        <span class="material-icons">close</span>
      </button>
    </div>

    <!-- Modal Content -->
    <div *ngIf="accountDetail" class="p-6 space-y-6 max-h-[75vh] overflow-y-auto custom-scrollbar">

      <div class="grid grid-cols-1 lg:grid-cols-3 gap-6">

        <!-- LEFT COLUMN: Profile info card & Quick Actions -->
        <div class="lg:col-span-1 space-y-6">

          <!-- Account Info -->
          <div
            class="glass-panel rounded-3xl p-6 space-y-6 relative overflow-hidden bg-slate-50/30 dark:bg-slate-800/20 border border-slate-100/50 dark:border-slate-800/50">
            <!-- <div class="absolute top-0 right-0 w-24 h-24 bg-amber-400/10 rounded-full blur-2xl -mr-6 -mt-6"></div> -->

            <div class="flex items-center gap-4 pb-4 border-b border-slate-100 dark:border-slate-800/80">
              <div
                class="w-12 h-12 bg-amber-100 dark:bg-amber-450/20 rounded-2xl flex items-center justify-center text-amber-600 dark:text-amber-400 shadow-inner">
                <span class="material-icons">account_circle</span>
              </div>
              <div>
                <h2 class="text-base font-extrabold text-slate-950 dark:text-slate-100">{{ accountDetail.fullName }}
                </h2>
                <p class="text-[10px] text-slate-400 dark:text-slate-500 font-extrabold tracking-widest uppercase mt-1">
                  เลขบัญชี: {{ accountDetail.topupNumber }}</p>
              </div>
            </div>

            <div class="space-y-4">
              <div class="flex items-center justify-between text-xs font-semibold">
                <span class="text-slate-450 dark:text-slate-400">เบอร์โทรศัพท์</span>
                <span class="font-bold text-slate-800 dark:text-slate-200">{{ accountDetail.phone }}</span>
              </div>
              <div class="flex items-center justify-between text-xs font-semibold">
                <span class="text-slate-455 dark:text-slate-400">วันที่สร้างบัญชี</span>
                <span class="font-bold text-slate-800 dark:text-slate-200">{{ accountDetail.createDate |
                  date:'dd/MM/yyyy HH:mm' }}</span>
              </div>
              <div
                class="flex items-center justify-between text-xs font-semibold border-t border-slate-100/50 dark:border-slate-800/50 pt-3">
                <span class="text-slate-455 dark:text-slate-400">สิทธิ์การปรับยอด</span>
                <span
                  [class]="accountDetail.canAdjustBalance ? 'text-green-600 dark:text-green-400 font-extrabold' : 'text-slate-400 dark:text-slate-500 font-extrabold'">
                  {{ accountDetail.canAdjustBalance ? 'ปรับยอดเงินได้' : 'ไม่มีสิทธิ์ปรับยอด' }}
                </span>
              </div>
            </div>
          </div>

          <!-- Balance Card & Action -->
          <div
            class="glass-panel rounded-3xl p-6 space-y-6 relative overflow-hidden bg-gradient-to-br from-slate-900 to-slate-950 text-white border-none shadow-xl">
            <div
              class="absolute -bottom-10 -right-10 w-44 h-44 bg-amber-400/10 rounded-full blur-3xl pointer-events-none">
            </div>

            <div class="space-y-1">
              <span
                class="text-[10px] font-black tracking-widest text-slate-400 uppercase">ยอดเงินคงเหลือปัจจุบัน</span>
              <div class="text-3.5xl font-black text-amber-400 tracking-tight">{{ accountDetail.amount | number:'1.2-2'
                }} <span class="text-xs font-extrabold text-slate-300">บาท</span></div>
            </div>

            <!-- Adjust Balance Button -->
            <button (click)="openAdjustBalanceDialog()" [disabled]="!accountDetail.canAdjustBalance"
              class="group w-full flex items-center justify-center gap-2 py-3.5 bg-amber-400 disabled:bg-slate-800 disabled:text-slate-500 text-slate-950 font-black rounded-2xl text-xs hover:bg-amber-500 transition-all duration-500 hover:scale-[1.02] shadow-[0_8px_16px_-4px_rgba(251,191,36,0.4)] hover:shadow-[0_12px_24px_-4px_rgba(251,191,36,0.6)] cursor-pointer disabled:cursor-not-allowed border-none disabled:shadow-none">
              <span class="material-icons text-sm transition-transform duration-300 group-hover:rotate-12">tune</span>
              ปรับเปลี่ยนยอดเงินบัญชี
            </button>
          </div>

        </div>

        <!-- RIGHT COLUMN: Transactions Tabs & History Tables -->
        <div class="lg:col-span-2 space-y-6">

          <div
            class="glass-panel rounded-3xl p-6 space-y-6 bg-slate-50/10 dark:bg-slate-800/5 border border-slate-100/50 dark:border-slate-800/50">

            <!-- Inner Tabs navigation -->
            <div
              class="flex items-center justify-between border-b border-slate-100 dark:border-slate-800/80 pb-3 h-full">
              <div class="flex gap-2">
                <button (click)="switchDetailTab('recent')"
                  [class]="detailTab === 'recent' 
                    ? 'px-3.5 py-2 text-xs font-bold text-amber-500 border-b-2 border-amber-500 transition-all duration-300'
                    : 'px-3.5 py-2 text-xs font-semibold text-slate-500 hover:text-slate-800 dark:hover:text-white transition-all duration-300 cursor-pointer'">
                  ธุรกรรมล่าสุด (10)
                </button>
                <button (click)="switchDetailTab('all')"
                  [class]="detailTab === 'all' 
                    ? 'px-3.5 py-2 text-xs font-bold text-amber-500 border-b-2 border-amber-500 transition-all duration-300'
                    : 'px-3.5 py-2 text-xs font-semibold text-slate-500 hover:text-slate-800 dark:hover:text-white transition-all duration-300 cursor-pointer'">
                  ธุรกรรมทั้งหมด
                </button>
                <!-- <button (click)="switchDetailTab('holds')"
                  [class]="detailTab === 'holds' 
                    ? 'px-3.5 py-2 text-xs font-bold text-amber-500 border-b-2 border-amber-500 transition-all duration-300'
                    : 'px-3.5 py-2 text-xs font-semibold text-slate-500 hover:text-slate-800 dark:hover:text-white transition-all duration-300 cursor-pointer'">
                  ยอด Hold ปัจจุบัน
                </button> -->
              </div>

              <!-- Tab Refresh Button -->
              <button (click)="switchDetailTab(detailTab)"
                class="text-slate-400 hover:text-slate-600 dark:hover:text-slate-300 transition-colors cursor-pointer">
                <span class="material-icons text-sm">refresh</span>
              </button>
            </div>

            <!-- TAB CONTENT 1: Recent Transactions (10 Items) -->
            <div *ngIf="detailTab === 'recent'" class="space-y-4">
              <div
                class="overflow-x-auto border border-slate-200/50 dark:border-slate-700/50 rounded-2xl custom-scrollbar shadow-sm bg-white/40 dark:bg-slate-900/10 h-[400px]">
                <table class="premium-table text-left text-xs">
                  <thead>
                    <tr
                      class="bg-slate-50/60 dark:bg-slate-800/40 border-b border-slate-100 text-slate-450 dark:text-slate-400 font-bold uppercase tracking-wider">
                      <th class="py-3 px-4">เลขธุรกรรม / วันที่</th>
                      <th class="py-3 px-4">ประเภท</th>
                      <th class="py-3 px-4 text-right">จำนวน</th>
                      <th class="py-3 px-4 text-right">คงเหลือ</th>
                      <th class="py-3 px-4 text-center">สถานะ</th>
                      <th class="py-3 px-4">หมายเหตุ</th>
                    </tr>
                  </thead>
                  <tbody class="divide-y divide-slate-100/80 dark:divide-slate-800/80">
                    <tr *ngFor="let tx of accountDetail.recentTransactions"
                      class="hover:bg-white/80 dark:hover:bg-slate-800/60 transition-colors animate-row-fade">
                      <td class="py-3.5 px-4">
                        <div class="font-extrabold text-slate-900 dark:text-slate-100">{{ tx.transactionNo || '-' }}
                        </div>
                        <div class="text-[9px] text-slate-400 dark:text-slate-500 font-bold mt-0.5">{{ tx.paidDate |
                          date:'dd/MM/yyyy HH:mm' }}</div>
                      </td>
                      <td class="py-3.5 px-4 font-bold text-xs">
                        <span
                          [class]="
                          tx.topupMethod === 1 ? 'text-blue-600 dark:text-blue-400' :
                          tx.topupMethod === 2 ? 'text-slate-550 dark:text-slate-450' :
                          tx.topupMethod === 3 ? 'text-green-600 dark:text-green-400' : 'text-rose-500 dark:text-rose-450'">
                          {{ tx.description }}
                        </span>
                      </td>
                      <td class="py-3.5 px-4 text-right font-black"
                        [class.text-green-600]="tx.topupMethod === 1 || tx.topupMethod === 3"
                        [class.text-rose-500]="tx.topupMethod === 2 || tx.topupMethod === 4">
                        {{ (tx.topupMethod === 1 || tx.topupMethod === 3 ? '+' : '-') }} {{ tx.amount | number:'1.2-2'
                        }}
                      </td>
                      <td class="py-3.5 px-4 text-right text-slate-700 dark:text-slate-300 font-bold">{{ tx.balance !=
                        null ? (tx.balance | number:'1.2-2') : '-' }}</td>
                      <td class="py-3.5 px-4 text-center">
                        <span
                          [class]="tx.isPendingApproval 
                          ? 'px-2 py-0.5 rounded-xl text-[9px] font-bold bg-amber-50 dark:bg-amber-950/30 text-amber-600 dark:text-amber-400 border border-amber-200/50' 
                          : 'px-2 py-0.5 rounded-xl text-[9px] font-bold bg-green-50 dark:bg-green-950/30 text-green-600 dark:text-green-400 border border-green-200/50'">
                          {{ tx.isPendingApproval ? 'รออนุมัติ' : 'สำเร็จ' }}
                        </span>
                      </td>
                      <td class="py-3.5 px-4 text-slate-400 dark:text-slate-500 font-semibold max-w-[150px] truncate"
                        [title]="tx.remark">{{ tx.remark || '-' }}</td>
                    </tr>
                    <tr *ngIf="accountDetail.recentTransactions.length === 0">
                      <td colspan="6" class="py-12 text-center">
                        <div
                          class="flex flex-col items-center justify-center p-5 border-2 border-dashed border-slate-200/60 dark:border-slate-700/60 rounded-3xl bg-slate-50/30 dark:bg-slate-800/20 max-w-sm mx-auto">
                          <div
                            class="w-14 h-14 bg-slate-100 dark:bg-slate-800 rounded-full flex items-center justify-center mb-3 shadow-inner">
                            <span
                              class="material-icons text-3xl text-slate-300 dark:text-slate-600 animate-bounce">receipt_long</span>
                          </div>
                          <h3 class="text-xs font-extrabold text-slate-700 dark:text-slate-300 mb-1">
                            ไม่มีประวัติธุรกรรมล่าสุด</h3>
                          <p class="text-[10px] text-slate-500 dark:text-slate-400 font-medium">
                            บัญชีนี้ยังไม่มีการเคลื่อนไหวของยอดเงิน</p>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <!-- TAB CONTENT 2: All Transactions (Paginated) -->
            <div *ngIf="detailTab === 'all'" class="space-y-4">
              <div
                class="overflow-x-auto border border-slate-200/50 dark:border-slate-700/50 rounded-2xl custom-scrollbar shadow-sm bg-white/40 dark:bg-slate-900/10 h-[400px]">
                <table class="premium-table text-left text-xs">
                  <thead>
                    <tr
                      class="bg-slate-50/60 dark:bg-slate-800/40 border-b border-slate-100 text-slate-450 dark:text-slate-400 font-bold uppercase tracking-wider">
                      <th class="py-3 px-4">เลขธุรกรรม / วันที่</th>
                      <th class="py-3 px-4">ประเภท</th>
                      <th class="py-3 px-4 text-right">จำนวน</th>
                      <th class="py-3 px-4 text-right">คงเหลือ</th>
                      <th class="py-3 px-4 text-center">สถานะ</th>
                      <th class="py-3 px-4">หมายเหตุ</th>
                    </tr>
                  </thead>
                  <tbody class="divide-y divide-slate-100/80 dark:divide-slate-800/80">
                    <tr *ngFor="let tx of accTransactions"
                      class="hover:bg-white/80 dark:hover:bg-slate-800/60 transition-colors animate-row-fade">
                      <td class="py-3.5 px-4">
                        <div class="font-extrabold text-slate-900 dark:text-slate-100">{{ tx.transactionNo || '-' }}
                        </div>
                        <div class="text-[9px] text-slate-400 dark:text-slate-500 font-bold mt-0.5">{{ tx.paidDate |
                          date:'dd/MM/yyyy HH:mm' }}</div>
                      </td>
                      <td class="py-3.5 px-4 font-bold text-xs">
                        <span
                          [class]="
                          tx.topupMethod === 1 ? 'text-blue-600 dark:text-blue-400' :
                          tx.topupMethod === 2 ? 'text-slate-550 dark:text-slate-455' :
                          tx.topupMethod === 3 ? 'text-green-600 dark:text-green-400' : 'text-rose-500 dark:text-rose-455'">
                          {{ tx.description }}
                        </span>
                      </td>
                      <td class="py-3.5 px-4 text-right font-black"
                        [class.text-green-600]="tx.topupMethod === 1 || tx.topupMethod === 3"
                        [class.text-rose-500]="tx.topupMethod === 2 || tx.topupMethod === 4">
                        {{ (tx.topupMethod === 1 || tx.topupMethod === 3 ? '+' : '-') }} {{ tx.amount | number:'1.2-2'
                        }}
                      </td>
                      <td class="py-3.5 px-4 text-right text-slate-700 dark:text-slate-300 font-bold">{{ tx.balance !=
                        null ? (tx.balance | number:'1.2-2') : '-' }}</td>
                      <td class="py-3.5 px-4 text-center">
                        <span
                          [class]="tx.isPendingApproval 
                          ? 'px-2 py-0.5 rounded-xl text-[9px] font-bold bg-amber-50 dark:bg-amber-950/30 text-amber-600 dark:text-amber-400 border border-amber-200/50' 
                          : 'px-2 py-0.5 rounded-xl text-[9px] font-bold bg-green-50 dark:bg-green-950/30 text-green-600 dark:text-green-400 border border-green-200/50'">
                          {{ tx.isPendingApproval ? 'รออนุมัติ' : 'สำเร็จ' }}
                        </span>
                      </td>
                      <td class="py-3.5 px-4 text-slate-400 dark:text-slate-500 font-semibold max-w-[150px] truncate"
                        [title]="tx.remark">{{ tx.remark || '-' }}</td>
                    </tr>
                    <tr *ngIf="accTransactions.length === 0">
                      <td colspan="6" class="py-12 text-center">
                        <div
                          class="flex flex-col items-center justify-center p-5 border-2 border-dashed border-slate-200/60 dark:border-slate-700/60 rounded-3xl bg-slate-50/30 dark:bg-slate-800/20 max-w-sm mx-auto">
                          <div
                            class="w-14 h-14 bg-slate-100 dark:bg-slate-800 rounded-full flex items-center justify-center mb-3 shadow-inner">
                            <span
                              class="material-icons text-3xl text-slate-300 dark:text-slate-600 animate-bounce">receipt_long</span>
                          </div>
                          <h3 class="text-xs font-extrabold text-slate-700 dark:text-slate-300 mb-1">ไม่มีรายการธุรกรรม
                          </h3>
                          <p class="text-[10px] text-slate-500 dark:text-slate-400 font-medium">
                            บัญชีนี้ยังไม่มีการเคลื่อนไหวของยอดเงิน</p>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <!-- Standard Pagination Footer -->
              <div class="flex flex-col sm:flex-row items-center justify-between gap-4 mt-6">
                <div class="flex items-center gap-3">
                  <span class="text-xs font-bold text-slate-500 dark:text-slate-400">
                    แสดง {{ accTxStartItemIndex }} - {{ accTxEndItemIndex }} จาก {{ accTxTotalItems }} รายการ
                  </span>

                  <!-- Page Size Dropdown -->
                  <div class="relative">
                    <button (click)="toggleAccTxPageSizeDropdown()" (blur)="closeAccTxPageSizeDropdown()"
                      class="flex items-center gap-1.5 px-3 py-1.5 bg-white dark:bg-slate-800 border border-slate-200/80 dark:border-slate-700/80 rounded-xl text-xs font-bold text-slate-700 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700 focus:outline-none cursor-pointer transition-all shadow-sm">
                      <span>{{ accTxPageSize }} / หน้า</span>
                      <span class="material-icons text-slate-400 text-sm transition-transform duration-200"
                        [class.rotate-180]="isAccTxPageSizeDropdownOpen">expand_more</span>
                    </button>

                    <div *ngIf="isAccTxPageSizeDropdownOpen" (mousedown)="$event.preventDefault()"
                      class="absolute bottom-full left-0 mb-2 z-50 min-w-[5rem] bg-white/95 dark:bg-slate-800/95 backdrop-blur-md border border-slate-100 dark:border-slate-700 rounded-xl shadow-lg py-1 animate-fade-in text-center">
                      <button *ngFor="let opt of pageSizeOptions" (click)="selectAccTxPageSize(opt)"
                        class="w-full text-center px-3 py-2 text-xs font-bold text-slate-700 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700/50 hover:text-amber-600 dark:hover:text-amber-400 block transition-colors cursor-pointer">
                        {{ opt }} / หน้า
                      </button>
                    </div>
                  </div>
                </div>

                <!-- Page Buttons -->
                <div class="flex items-center gap-1">
                  <button (click)="setAccTxPage(accTxCurrentPage - 1)" [disabled]="accTxCurrentPage === 1"
                    class="w-8 h-8 rounded-xl border border-slate-200/60 dark:border-slate-700/60 bg-white dark:bg-slate-800 text-slate-400 disabled:opacity-40 hover:bg-slate-50 dark:hover:bg-slate-700 flex items-center justify-center cursor-pointer">
                    <span class="material-icons text-sm">chevron_left</span>
                  </button>

                  <ng-container *ngFor="let page of accTxPagesArray">
                    <button *ngIf="page === accTxCurrentPage"
                      class="w-8 h-8 rounded-xl bg-amber-400 text-slate-900 font-black shadow-[0_4px_12px_rgba(251,191,36,0.35)] flex items-center justify-center text-xs">
                      {{ page }}
                    </button>
                    <button *ngIf="page !== accTxCurrentPage" (click)="setAccTxPage(page)"
                      class="w-8 h-8 rounded-xl text-slate-650 dark:text-slate-300 font-bold hover:bg-slate-50 dark:hover:bg-slate-700 hover:text-amber-500 dark:hover:text-amber-400 flex items-center justify-center text-xs cursor-pointer">
                      {{ page }}
                    </button>
                  </ng-container>

                  <button (click)="setAccTxPage(accTxCurrentPage + 1)" [disabled]="accTxCurrentPage === accTxTotalPages"
                    class="w-8 h-8 rounded-xl border border-slate-200/60 dark:border-slate-700/60 bg-white dark:bg-slate-800 text-slate-400 disabled:opacity-40 hover:bg-slate-50 dark:hover:bg-slate-700 flex items-center justify-center cursor-pointer">
                    <span class="material-icons text-sm">chevron_right</span>
                  </button>
                </div>
              </div>
            </div>

            <!-- TAB CONTENT 3: Holds active -->
            <div *ngIf="detailTab === 'holds'" class="space-y-4">
              <div
                class="overflow-x-auto border border-slate-200/50 dark:border-slate-700/50 rounded-2xl custom-scrollbar shadow-sm bg-white/40 dark:bg-slate-900/10">
                <table class="premium-table text-left text-xs">
                  <thead>
                    <tr
                      class="bg-slate-50/60 dark:bg-slate-800/40 text-slate-450 dark:text-slate-400 font-bold uppercase tracking-wider">
                      <th class="py-3 px-4">รายการ</th>
                      <th class="py-3 px-4 text-right">ยอด Hold</th>
                      <th class="py-3 px-4 text-center">วันที่สร้าง</th>
                      <th class="py-3 px-4">หมายเหตุ</th>
                    </tr>
                  </thead>
                  <tbody class="divide-y divide-slate-100/80 dark:divide-slate-800/80">
                    <tr *ngFor="let hold of accHolds"
                      class="hover:bg-white/80 dark:hover:bg-slate-800/60 transition-colors animate-row-fade">
                      <td class="py-3.5 px-4 font-bold text-slate-800 dark:text-slate-200">{{ hold.name || '-' }}</td>
                      <td class="py-3.5 px-4 text-right font-extrabold text-amber-600 dark:text-amber-400 text-sm">{{
                        hold.amount | number:'1.2-2' }} บาท</td>
                      <td class="py-3.5 px-4 text-center text-slate-400 dark:text-slate-550 font-semibold">{{
                        hold.createDate | date:'dd/MM/yyyy HH:mm' }}</td>
                      <td class="py-3.5 px-4 text-slate-400 dark:text-slate-500 font-semibold max-w-[200px] truncate"
                        [title]="hold.remark">{{ hold.remark || '-' }}</td>
                    </tr>
                    <tr *ngIf="accHolds.length === 0">
                      <td colspan="4" class="py-8 text-center text-slate-400 dark:text-slate-500 font-bold text-xs">
                        ไม่มีรายการจองยอดเงิน (Hold)</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <!-- Standard Pagination Footer -->
              <div class="flex flex-col sm:flex-row items-center justify-between gap-4 mt-6">
                <div class="flex items-center gap-3">
                  <span class="text-xs font-bold text-slate-500 dark:text-slate-400">
                    แสดง {{ accHoldStartItemIndex }} - {{ accHoldEndItemIndex }} จาก {{ accHoldTotalItems }} รายการ
                  </span>

                  <!-- Page Size Dropdown -->
                  <div class="relative">
                    <button (click)="toggleAccHoldPageSizeDropdown()" (blur)="closeAccHoldPageSizeDropdown()"
                      class="flex items-center gap-1.5 px-3 py-1.5 bg-white dark:bg-slate-800 border border-slate-200/80 dark:border-slate-700/80 rounded-xl text-xs font-bold text-slate-700 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700 focus:outline-none cursor-pointer transition-all shadow-sm">
                      <span>{{ accHoldPageSize }} / หน้า</span>
                      <span class="material-icons text-slate-400 text-sm transition-transform duration-200"
                        [class.rotate-180]="isAccHoldPageSizeDropdownOpen">expand_more</span>
                    </button>

                    <div *ngIf="isAccHoldPageSizeDropdownOpen" (mousedown)="$event.preventDefault()"
                      class="absolute bottom-full left-0 mb-2 z-50 min-w-[5rem] bg-white/95 dark:bg-slate-800/95 backdrop-blur-md border border-slate-100 dark:border-slate-700 rounded-xl shadow-lg py-1 animate-fade-in text-center">
                      <button *ngFor="let opt of pageSizeOptions" (click)="selectAccHoldPageSize(opt)"
                        class="w-full text-center px-3 py-2 text-xs font-bold text-slate-700 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700/50 hover:text-amber-600 dark:hover:text-amber-400 block transition-colors cursor-pointer">
                        {{ opt }} / หน้า
                      </button>
                    </div>
                  </div>
                </div>

                <!-- Page Buttons -->
                <div class="flex items-center gap-1">
                  <button (click)="setAccHoldPage(accHoldCurrentPage - 1)" [disabled]="accHoldCurrentPage === 1"
                    class="w-8 h-8 rounded-xl border border-slate-200/60 dark:border-slate-700/60 bg-white dark:bg-slate-800 text-slate-400 disabled:opacity-40 hover:bg-slate-50 dark:hover:bg-slate-700 flex items-center justify-center cursor-pointer">
                    <span class="material-icons text-sm">chevron_left</span>
                  </button>

                  <ng-container *ngFor="let page of accHoldPagesArray">
                    <button *ngIf="page === accHoldCurrentPage"
                      class="w-8 h-8 rounded-xl bg-amber-400 text-slate-900 font-black shadow-[0_4px_12px_rgba(251,191,36,0.35)] flex items-center justify-center text-xs">
                      {{ page }}
                    </button>
                    <button *ngIf="page !== accHoldCurrentPage" (click)="setAccHoldPage(page)"
                      class="w-8 h-8 rounded-xl text-slate-600 dark:text-slate-300 font-bold hover:bg-slate-50 dark:hover:bg-slate-700 hover:text-amber-500 dark:hover:text-amber-400 flex items-center justify-center text-xs cursor-pointer">
                      {{ page }}
                    </button>
                  </ng-container>

                  <button (click)="setAccHoldPage(accHoldCurrentPage + 1)"
                    [disabled]="accHoldCurrentPage === accHoldTotalPages"
                    class="w-8 h-8 rounded-xl border border-slate-200/60 dark:border-slate-700/60 bg-white dark:bg-slate-800 text-slate-400 disabled:opacity-40 hover:bg-slate-50 dark:hover:bg-slate-700 flex items-center justify-center cursor-pointer">
                    <span class="material-icons text-sm">chevron_right</span>
                  </button>
                </div>
              </div>
            </div>

          </div>

        </div>

      </div>

    </div>

    <!-- Modal Footer -->
    <div
      class="px-6 py-4 border-t border-slate-100 dark:border-slate-800/80 flex justify-between gap-2 bg-slate-50/50 dark:bg-slate-900/50">
      <button *ngIf="canShowActivityHistory" type="button" (click)="openActivityHistory()"
        class="px-5 py-2.5 rounded-2xl border border-slate-200 dark:border-slate-700 hover:border-amber-400 hover:text-amber-600 text-slate-600 dark:text-slate-400 font-bold text-xs cursor-pointer transition-colors inline-flex items-center gap-2">
        <span class="material-icons text-base">history</span>
        ดูประวัติ
      </button>
      <button (click)="closeModal()"
        class="px-5 py-2.5 rounded-2xl border border-slate-200 dark:border-slate-700 hover:bg-slate-100 dark:hover:bg-slate-800 text-slate-600 dark:text-slate-400 font-bold text-xs cursor-pointer transition-colors ml-auto">
        ปิดรายละเอียด
      </button>
    </div>

  </div>

</div>

<!-- ================= DIALOG MODAL: Adjust Balance Form ================= -->
<div *ngIf="isAdjustOpen && accountDetail"
  class="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/60 backdrop-blur-md p-4 animate-fade-in text-slate-800 dark:text-slate-200">
  <div
    class=" w-full max-w-md rounded-3xl shadow-2xl p-6 relative overflow-hidden bg-white/95 dark:bg-slate-900/95 animate-fade-in-up border border-slate-100/50 dark:border-slate-800/50">
    <div class="absolute -top-10 -right-10 w-24 h-24 bg-amber-400/10 rounded-full blur-2xl pointer-events-none"></div>

    <div class="flex items-center justify-between pb-3 border-b border-slate-100 dark:border-slate-800/80">
      <h3 class="text-sm font-extrabold text-slate-800 dark:text-white flex items-center gap-2">
        <span class="material-icons text-amber-500 text-lg">tune</span>
        ปรับเปลี่ยนยอดเงินบัญชี
      </h3>
      <button (click)="closeAdjustBalanceDialog()"
        class="text-slate-400 hover:text-slate-600 dark:hover:text-slate-200 transition-colors cursor-pointer">
        <span class="material-icons">close</span>
      </button>
    </div>

    <!-- Form Content -->
    <div class="py-4 space-y-4">
      <!-- Account Info Display -->
      <div
        class="bg-slate-50/50 dark:bg-slate-800/50 rounded-2xl p-4 space-y-2.5 border border-slate-300/50 dark:border-slate-700 shadow-inner ">
        <div class="flex justify-between text-xs">
          <span class="text-slate-400 dark:text-slate-500 font-bold">บัญชีที่ปรับปรุง:</span>
          <span class="font-extrabold text-slate-800 dark:text-slate-200">{{ accountDetail.topupNumber }}</span>
        </div>
        <div class="flex justify-between text-xs">
          <span class="text-slate-400 dark:text-slate-500 font-bold">ชื่อลูกค้า:</span>
          <span class="font-extrabold text-slate-800 dark:text-slate-200">{{ accountDetail.fullName }}</span>
        </div>
        <div class="flex justify-between text-xs border-t border-slate-200/50 dark:border-slate-750 pt-2.5 mt-2.5">
          <span class="text-slate-400 dark:text-slate-500 font-black">ยอดเงินปัจจุบัน:</span>
          <span class="font-black text-amber-600 dark:text-amber-400 text-sm">{{ accountDetail.amount | number:'1.2-2'
            }} บาท</span>
        </div>
      </div>

      <!-- Adjust Type (Segmented control) -->
      <div class="space-y-2">
        <label
          class="text-xs font-black text-slate-500 dark:text-slate-400 uppercase tracking-wide">ประเภทการปรับปรุง</label>
        <div
          class="flex bg-slate-100 dark:bg-slate-950/80 p-1 rounded-2xl border border-slate-200/40 dark:border-slate-800">
          <button type="button" (click)="adjustMethod = 3"
            [class]="adjustMethod === 3 
              ? 'w-1/2 py-2.5 bg-white dark:bg-slate-800 text-green-600 dark:text-green-400 font-black rounded-xl shadow-sm text-xs transition-all duration-300 border-none'
              : 'w-1/2 py-2.5 text-slate-500 font-bold hover:text-slate-700 text-xs transition-all duration-300 cursor-pointer border-none bg-transparent'">
            <span class="inline-block w-2.5 h-2.5 rounded-full bg-green-500 mr-1.5"></span>
            เพิ่มยอดเงิน (+)
          </button>
          <button type="button" (click)="adjustMethod = 4"
            [class]="adjustMethod === 4 
              ? 'w-1/2 py-2.5 bg-white dark:bg-slate-800 text-rose-500 dark:text-rose-455 font-black rounded-xl shadow-sm text-xs transition-all duration-300 border-none'
              : 'w-1/2 py-2.5 text-slate-500 font-bold hover:text-slate-700 text-xs transition-all duration-300 cursor-pointer border-none bg-transparent'">
            <span class="inline-block w-2.5 h-2.5 rounded-full bg-rose-500 mr-1.5"></span>
            ปรับลดยอดเงิน (-)
          </button>
        </div>
      </div>

      <!-- Adjust Amount -->
      <div class="space-y-2">
        <label
          class="text-xs font-black text-slate-500 dark:text-slate-400 uppercase tracking-wide">จำนวนเงินที่ปรับปรุง</label>
        <div
          class="flex items-center border border-slate-200 dark:border-slate-700 focus-within:ring-4 focus-within:ring-amber-400/20 focus-within:border-amber-400 rounded-2xl px-4 py-2.5 bg-white dark:bg-slate-800 transition-all duration-300 shadow-sm">
          <input type="number" [(ngModel)]="adjustAmount" placeholder="ระบุจำนวนเงินมากกว่า 0..."
            class="w-full text-xs font-extrabold outline-none border-none bg-transparent text-slate-700 dark:text-slate-200" />
          <span class="text-xs text-slate-450 dark:text-slate-500 font-extrabold ml-2">บาท</span>
        </div>
      </div>

      <!-- Remark -->
      <div class="space-y-2">
        <label
          class="text-xs font-black text-slate-500 dark:text-slate-400 uppercase tracking-wide">หมายเหตุเหตุผลการปรับปรุง
          <span class="text-rose-500">*</span></label>
        <textarea [(ngModel)]="adjustRemark" placeholder="ระบุเหตุผลและหลักฐาน เช่น ปรับยอดเนื่องจากสลิปตกหล่น..."
          rows="3"
          class="w-full text-xs font-semibold border border-slate-200 dark:border-slate-700 focus:ring-4 focus:ring-amber-400/20 focus:border-amber-400 rounded-2xl p-3 outline-none transition-all duration-300 shadow-sm resize-none bg-white dark:bg-slate-800 text-slate-700 dark:text-slate-250"></textarea>
      </div>
    </div>

    <!-- Action buttons -->
    <div class="flex gap-3 pt-3 border-t border-slate-100 dark:border-slate-800/80">
      <button (click)="closeAdjustBalanceDialog()"
        class="w-1/2 py-3.5 border border-slate-200 dark:border-slate-700 hover:bg-slate-50 dark:hover:bg-slate-800 text-slate-600 dark:text-slate-400 font-bold rounded-2xl text-xs cursor-pointer transition-colors bg-transparent">
        ยกเลิก
      </button>
      <button (click)="submitAdjustRequest()"
        class="w-1/2 py-3.5 bg-amber-400 hover:bg-amber-500 text-slate-900 font-black rounded-2xl text-xs cursor-pointer transition-all duration-300 hover:shadow-[0_8px_16px_-4px_rgba(251,191,36,0.5)] border-none hover:-translate-y-0.5">
        บันทึกคำขอปรับปรุง
      </button>
    </div>
  </div>
</div>

<!-- ================= SHARED COMPONENT: Confirm Modal ================= -->
<app-pss-confirm-modal *ngIf="isConfirmOpen && accountDetail" title="ยืนยันการปรับยอดเงินบัญชี?"
  message="คุณแน่ใจหรือไม่ว่าต้องการบันทึกคำขอปรับยอดเงินสำหรับบัญชี"
  [highlight]="accountDetail.topupNumber + ' (' + accountDetail.fullName + ')'"
  [messageSuffix]="'เป็นจำนวนเงิน ' + (adjustAmount | number:'1.2-2') + ' บาท โดยทำการ' + (adjustMethod === 3 ? 'ปรับเพิ่มยอด (+)' : 'ปรับลดเงิน (-)') + ' หรือไม่?'"
  confirmLabel="ยืนยันการบันทึก" variant="warning" icon="tune" [showIrreversibleNote]="true"
  (confirm)="confirmAdjustBalance()" (cancel)="cancelConfirm()">
</app-pss-confirm-modal>

<!-- ================= SHARED COMPONENT: Loading Overlay ================= -->
<!-- CRITICAL: Place app-pss-loading outside the outermost main div wrapper to display properly as a fullscreen overlay -->
<app-pss-loading *ngIf="isLoading"></app-pss-loading>

<app-modal-admin-activity-history
  *ngIf="showActivityHistory && accountId"
  [entityType]="activityEntityTypes.TopupAccount"
  [entityId]="accountId"
  title="ประวัติบัญชีเติมเงิน"
  [subtitle]="'#' + accountId"
  (close)="closeActivityHistory()">
</app-modal-admin-activity-history>